import React from "react";

// layout first to silence conflict css generation error
import Layout from "../core/layout/layout";

import { graphql } from "gatsby";
import {
  filterOutDocsPublishedInTheFuture,
  filterOutDocsWithoutSlugs,
  mapEdgesToNodes,
} from "../core/sanity/lib/helpers";
import BlogPostPreviewList from "../blog/components/blog-post-preview-grid";
import Container from "../blog/components/container";
import GraphQLErrorList from "../blog/components/graphql-error-list";
import Seo from "../core/layout/seo";

// preview image of website
import WebsitePreview from '../landing/assets/WebsitePreview.png';

import { Breadcrumb } from 'gatsby-plugin-breadcrumb';
import { BreadcrumbContainer } from '../core/NavigationStyles';

export const query = graphql`
  fragment SanityImage on SanityMainImage {
    crop {
      _key
      _type
      top
      bottom
      left
      right
    }
    hotspot {
      _key
      _type
      x
      y
      height
      width
    }
    asset {
      _id
    }
  }

  query BlogPageQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
      keywords
    }
    posts: allSanityPost(
      sort: { fields: [publishedAt], order: DESC }
      filter: { slug: { current: { ne: null } }, publishedAt: { ne: null } }
    ) {
      edges {
        node {
          id
          publishedAt
          mainImage {
            ...SanityImage
            alt
          }
          title
          _rawExcerpt
          slug {
            current
          }
        }
      }
    }
  }
`;

const BlogPage = (props) => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const site = (data || {}).site;
  const postNodes = (data || {}).posts
    ? mapEdgesToNodes(data.posts)
        .filter(filterOutDocsWithoutSlugs)
        .filter(filterOutDocsPublishedInTheFuture)
    : [];

  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    );
  }

  return (
    <Layout>
      <Seo
        title={'Blog'}
        // description is currently written specifically for blog
        description={site.description}
        keywords={site.keywords}
        setImage={WebsitePreview}
      />

      <Container>
        <BreadcrumbContainer>
          <Breadcrumb style={{color: 'var(--color-gray)'}} location={props.location} crumbLabel={"Blog"} />
        </BreadcrumbContainer>
        {postNodes && (
          <BlogPostPreviewList
            title="John's Blog"
            nodes={postNodes}
            // Removing browseMoreRef to handle this page as the main blog page with /browse being unaccessable
            // browseMoreHref="/browse"
          />
        )}
      </Container>
    </Layout>
  );
};

export default BlogPage;
